export const colors = {
    "N/A": "#fad75a",
    "1★": "#666666",
    "2★": "#1e7d22",
    "3★": "#3366cc",
    "4★": "#684273",
    "5★": "#ffbf00",
    "6★": "#ff7f00",
    "7★": "#d0011b",
};